import React, { useEffect, useMemo, useState } from "react";
import NumberFormat from "react-number-format";
import { useApp } from "../../contexts";

function Item(props) {
  const { T } = useApp();
  const { data, handleClick, isHome } = props;

  const count = 4;
  return (
    <>
      {isHome ? (
        <div
          onClick={() => handleClick()}
          className={`flex justify-start items-center gap-[42px] py-[10px] lg:py-0`}
        >
          <div className="hidden lg:block lg:w-[114px] lg:h-[92px] xls:w-[134px] xls:h-[110px]  rounded-[20px] p-[15px] bg-[#F7F7F7]">
            <img
              src={"/assets/images/item-energy.svg"}
              className="object-contain  w-full h-full"
              alt=""
            />
          </div>
          <div className="hidden lg:flex  flex-col items-start justify-start flex-1">
            <p className="leading-[22px] text-[20px] text-[#000] font-[500] mb-[6px]">
              {T("TOTAL ENERGY")}
            </p>
            <p className="leading-[22px] text-[16px] text-[#000] font-[400]">
              {T("Use energy to walk your avatars and earn!")}
            </p>
          </div>
          <div className="flex gap-[2px] lg:hidden items-start justify-start flex-1">
            <div className="w-[37px] h-[37px] p-[5px] rounded-[5px] bg-[#F7F7F7]">
              <img
                src={"/assets/images/item-energy.svg"}
                className="object-contain  w-full h-full"
                alt=""
              />
            </div>
          </div>
          <div className="text-[#272729] text-[16px] lg:text-[20px] font-[600] flex justify-end">
            <NumberFormat
              value={data?.dogFood}
              displayType={"text"}
              thousandSeparator={true}
              suffix={"e"}
              decimalScale={3}
            />
          </div>
        </div>
      ) : (
        <div
          className={`flex justify-start items-start lg:items-center gap-[12px] px-[20px] py-[20px] lg:px-[27px] lg:py-[20px] lg:gap-[42px] bg-white rounded-[20px] lg:item-boxshadow`}
        >
          <div className="w-[90px] h-[80px] lg:w-[134px] lg:h-[130px] px-[5px] py-[10px] rounded-[20px] bg-[#F1E4E1]">
            <img
              src={"/assets/images/item-energy.svg"}
              className="object-contain  w-full h-full"
              alt=""
            />
          </div>
          <div className="flex  flex-col items-start justify-start flex-1">
            <p className="leading-[22px] text-[16px] lg:text-[20px] text-[#000] font-[500] mb-[6px]">
              {T("TOTAL ENERGY")}
            </p>
            <p className="leading-[22px] text-[12px] lg:text-[16px] text-[#000] font-[400]">
              {T("Open AI Avatar app and use energy to walk your avatars.")}
            </p>
            <div className="text-[#000] text-[14px] font-[600] flex lg:hidden">
              <NumberFormat
                value={data?.dogFood}
                displayType={"text"}
                thousandSeparator={true}
                suffix={"e"}
                decimalScale={3}
              />
            </div>
          </div>
          <div className="text-[#272729] text-[16px] lg:text-[20px] font-[600] hidden lg:flex justify-end">
            <NumberFormat
              value={data?.dogFood}
              displayType={"text"}
              thousandSeparator={true}
              suffix={"e"}
              decimalScale={3}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Item;
